module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGGyumaoC-4ba8f07eb006d7d0ea5c9796e24aae35.png";